/* Volufiline — Results: before/after drag slider + area tabs (sections/vf-ba.liquid). */
(function () {
  if (window.__vfBa) return;
  window.__vfBa = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(what) {
    try {
      (window.dataLayer = window.dataLayer || []).push({ event: 'volufiline_click', what: what });
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('volufiline_click', { what: what });
    } catch (e) {}
  }

  function init(root) {
    if (root.__vfBa) return;
    root.__vfBa = true;
    var frame = root.querySelector('[data-vf-ba-frame]');
    var handle = root.querySelector('[data-vf-ba-handle]');
    if (!frame || !handle) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vf-ba-tab]'));
    var pairs = Array.prototype.slice.call(root.querySelectorAll('[data-vf-ba-pair]'));
    var pos = 50, dragging = false, dragged = false, anim = 0;

    function set(p) {
      pos = Math.max(0, Math.min(100, p));
      frame.style.setProperty('--pos', pos + '%');
      frame.classList.toggle('is-lo', pos < 14);
      frame.classList.toggle('is-hi', pos > 86);
      var r = Math.round(pos);
      handle.setAttribute('aria-valuenow', r);
      handle.setAttribute('aria-valuetext', r + '% before, ' + (100 - r) + '% after');
    }
    function fromX(x) {
      var b = frame.getBoundingClientRect();
      if (b.width) set(((x - b.left) / b.width) * 100);
    }
    function stopAnim() { if (anim) { cancelAnimationFrame(anim); anim = 0; } }

    frame.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      stopAnim();
      dragging = true;
      frame.classList.add('is-drag');
      try { frame.setPointerCapture(e.pointerId); } catch (err) {}
      fromX(e.clientX);
      if (e.pointerType === 'mouse') { e.preventDefault(); handle.focus({ preventScroll: true }); }
    });
    frame.addEventListener('pointermove', function (e) { if (dragging) fromX(e.clientX); });
    function end() {
      if (!dragging) return;
      dragging = false;
      frame.classList.remove('is-drag');
      if (!dragged) { dragged = true; track('ba-drag'); }
    }
    frame.addEventListener('pointerup', end);
    frame.addEventListener('pointercancel', end);
    frame.addEventListener('lostpointercapture', end);

    handle.addEventListener('keydown', function (e) {
      var k = e.key, step = e.shiftKey ? 10 : 5, n = null;
      if (k === 'ArrowLeft' || k === 'ArrowDown') n = pos - step;
      else if (k === 'ArrowRight' || k === 'ArrowUp') n = pos + step;
      else if (k === 'PageDown') n = pos - 20;
      else if (k === 'PageUp') n = pos + 20;
      else if (k === 'Home') n = 0;
      else if (k === 'End') n = 100;
      if (n === null) return;
      e.preventDefault();
      stopAnim();
      set(n);
    });

    function show(i, focus) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on) {
          frame.setAttribute('aria-labelledby', t.id);
          if (focus) t.focus();
        }
      });
      pairs.forEach(function (p, j) {
        var on = j === i;
        p.classList.toggle('is-on', on);
        if (on) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
        if (on) Array.prototype.forEach.call(p.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
      });
      set(50);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n === null) return;
        e.preventDefault();
        show(n, true);
      });
    });

    /* Warm the other areas' photos once the section is near, so a tab switch never shows an empty frame. */
    function warm() {
      pairs.forEach(function (p) {
        Array.prototype.forEach.call(p.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
      });
    }

    /* One gentle sweep the first time the slider is on screen, so it reads as draggable. */
    function hint() {
      if (reduce || dragged) return;
      var t0 = null, dur = 1400;
      function tick(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        set(50 + Math.sin(k * Math.PI * 2) * 14 * (1 - k * 0.3));
        if (k < 1 && !dragging) anim = requestAnimationFrame(tick); else { anim = 0; if (!dragging) set(50); }
      }
      anim = requestAnimationFrame(tick);
    }

    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { near.disconnect(); warm(); }
      }, { rootMargin: '400px 0px' });
      near.observe(frame);
      var seen = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { seen.disconnect(); setTimeout(hint, 350); }
      }, { threshold: 0.6 });
      seen.observe(frame);
    } else {
      warm();
    }
    set(50);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-vf-ba]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
